const userTypeOptions = [
  { value: 'standard', label: 'Standard' },
  { value: 'impulsStudent', label: 'Uczeń Impuls' },
];
export default userTypeOptions;
